import { createContext, useState } from "react";

export const AgentContext = createContext();

const AgentDataProvider = ({ children }) => {
  const [agentData, setAgentData] = useState();
  const agentCollectData = (data) => {

    setAgentData(data);
  };

  return (
    <AgentContext.Provider value={{ agentCollectData, agentData }}>
      {children}
    </AgentContext.Provider>
  );
};
export default AgentDataProvider;
